import { AbstractModelSchema } from './abstract_model_schema.js';
export const menuTimingSchema = {
    displayName: 'day part',
    type: 'object',
    fields: {
        ...AbstractModelSchema.fields,
        orgId: {
            type: 'mongoId',
            isHidden: true,
            isReadOnly: true,
        },
        locationId: {
            type: 'mongoId',
            isHidden: true,
            isReadOnly: true,
        },
        menuId: {
            type: 'mongoId',
            isHidden: true,
            isReadOnly: true,
        },
        magicCopyKey: {
            type: 'keyString',
            isHidden: true,
            isReadOnly: true,
        },
        name: {
            type: 'shortString',
            required: true,
        },
        dateRange: {
            type: 'object',
            subtype: 'DateRange',
            displayName: 'Date Range',
        },
        mon: {
            type: 'object',
            subtype: 'HourRange',
            displayName: 'Monday',
        },
        tue: {
            type: 'object',
            subtype: 'HourRange',
            displayName: 'Tuesday',
        },
        wed: {
            type: 'object',
            subtype: 'HourRange',
            displayName: 'Wednesday',
        },
        thu: {
            type: 'object',
            subtype: 'HourRange',
            displayName: 'Thursday',
        },
        fri: {
            type: 'object',
            subtype: 'HourRange',
            displayName: 'Friday',
        },
        sat: {
            type: 'object',
            subtype: 'HourRange',
            displayName: 'Saturday',
        },
        sun: {
            type: 'object',
            subtype: 'HourRange',
            displayName: 'Sunday',
        },
    },
};
//# sourceMappingURL=menu_timing_schema.js.map